import Backbone from 'backbone';

let Router = Backbone.Router.extend({
    routes: {
        '': 'index',
        'embed/:id': 'embed',
        'embed/:id/': 'embed',
        'forgot-password': 'forgot-password',
        'sign-up': 'signup',
        'sign-in': 'signin',
        'sign-out': 'signout',
        technology: 'slatepage',
        'technology/': 'slatepage',
        leadership: 'slatepage',
        'leadership/': 'slatepage',
        search: 'search',
        videos: 'videos',
        'newsletters': 'newsletters',
        'videos/:program/:programname': 'videos',
        'section/:section': 'collection',
        'user/:author': 'author',
        'person/:person': 'person',
        'company/:company': 'company',
        'company/': 'companies',
        'company': 'companies',
        'most-innovative-companies/': 'most-innovative-companies',
        'most-innovative-companies': 'most-innovative-companies',
        'most-innovative-companies/sectors': 'most-innovative-companies',
        'most-innovative-companies/sectors/': 'most-innovative-companies',
        'most-innovative-companies/sectors/:sector': 'most-innovative-companies',
        'magazine/:magazine/': 'magazine',
        'magazine/:num/:monthYear': 'magazine',
        'magazine/:num/:monthYear/': 'magazine',
        ':id/:title': 'post',
        ':id/:title/': 'post',
        ':id/:supertag/:title': 'post',
        ':id/:supertag/:title/': 'post',
        ':id/:supertag/:title/:slideIndex': 'post',
        ':id/:supertag/:title/:slideIndex/': 'post'
    }
});

export default new Router(); // eslint-disable-line no-new
